'use client'

import ProductResponsive from '@/app/[locale]/product/[slug]/responsive'
import {
  DialogBody,
  DialogCloseTrigger,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogRoot,
} from '@/components/ui/dialog'
import { useProductCartRedirect } from '@/app/[locale]/_hooks/useProductCartRedirect'
import { useBreakpointValue } from '@chakra-ui/react'
import React from 'react'
import { IProduct } from '../../_types'
import { useProductModalData } from './useProductModalData'

export default function ProductDetailModal({
  data: preview,
  onClose,
}: {
  data: IProduct
  onClose: () => void
}) {
  const data = useProductModalData(preview)
  const onRedirectToCart = useProductCartRedirect(onClose)
  const isDesktop = useBreakpointValue(
    { base: false, lg: true },
    { ssr: false }
  )

  if (isDesktop) {
    return (
      <DialogRoot
        open={true}
        placement='center'
        scrollBehavior='inside'
        motionPreset='slide-in-bottom'
        onOpenChange={(e) => {
          if (!e.open) onClose()
        }}
      >
        <DialogContent maxW={'1200px'} mx={4} rounded='xl'>
          <DialogHeader p={0} pt={2}></DialogHeader>
          <DialogBody p={0} px={2}>
            <ProductResponsive
              data={data}
              onSuccess={onClose}
              onRedirectToCart={onRedirectToCart}
            />
          </DialogBody>
          <DialogCloseTrigger
            display={{ base: 'none', lg: 'flex' }}
            color='text'
            _hover={{ bg: 'background' }}
          />
          <DialogFooter pt={0}></DialogFooter>
        </DialogContent>
      </DialogRoot>
    )
  }
  return (
    <DialogRoot
      open={true}
      size='full'
      scrollBehavior='outside'
      motionPreset='slide-in-bottom'
      onOpenChange={(e) => {
        if (!e.open) onClose()
      }}
    >
      <DialogContent>
        <DialogBody
          p={0}
          display='flex'
          flexDirection='column'
          flex={1}
          minHeight='0'
        >
          <ProductResponsive
            data={data}
            onSuccess={onClose}
            onRedirectToCart={onRedirectToCart}
          />
        </DialogBody>
      </DialogContent>
    </DialogRoot>
  )
}
